import { BaseService } from './BaseService';
import { Ftp, ApiResponse } from '../../types/api.types';
import { validateFtp } from '../../validation/schemas';
import { API_ENDPOINTS } from './config';
import { api } from '../../services/api/api';

export class FtpService extends BaseService<Ftp> {
    protected endpoint = API_ENDPOINTS.FTP;

    protected validate(data: Partial<Ftp>) {
        return validateFtp(data as any);
    }

    async getFtpById(id: number): Promise<Ftp> {
        return this.getById<Ftp>(id);
    }

    async getAllFtps(query: string, page: number, pageSize: number): Promise<ApiResponse<Ftp[]>> {
        const response = await api.get<ApiResponse<Ftp[]>>(this.endpoint, {
            params: {
                keyword: query,
                page,
                pageSize
            }
        });
        return response.data;
    }

    async createFtp(data: Omit<Ftp, 'id' | 'createdAt' | 'updatedAt'>): Promise<Ftp> {
        return this.create<Ftp>(data);
    }

    async updateFtp(id: number, data: Partial<Ftp>): Promise<Ftp> {
        return this.update<Ftp>(id, data);
    }

    async deleteFtp(id: number): Promise<void> {
        return this.delete(id);
    }

    async testConnection(data: Omit<Ftp, 'id' | 'createdAt' | 'updatedAt'>): Promise<{ success: boolean; message: string; error?: string }> {
        return this.request<{ success: boolean; message: string; error?: string }>({
            method: 'POST',
            url: `${this.endpoint}/test-connection`,
            body: JSON.stringify(data),
        } as RequestInit);
    }

    async uploadFile(ftpId: number, file: Blob, filename: string): Promise<void> {
        const formData = new FormData();
        formData.append('file', file, filename);
        
        // Get FTP details first
        const ftpDetails = await this.getFtpById(ftpId);
        
        // Add FTP connection details to the form data
        formData.append('protocol', ftpDetails.protocol);
        formData.append('host', ftpDetails.host);
        formData.append('port', ftpDetails.port.toString());
        formData.append('username', ftpDetails.user);
        formData.append('password', ftpDetails.password);
        
        await api.post(`${this.endpoint}/${ftpId}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}

export const ftpService = new FtpService(); 